import React from 'react';
import { useTranslations } from 'next-intl';

import { calculateDiscount } from 'modules/global';

import { Visible } from 'components';

interface IProps {
  price?: number;
  discountPercent?: number;
  isFree?: boolean;
}

const CoursePrice: React.FC<IProps> = ({ discountPercent, isFree, price }) => {
  const t = useTranslations();

  return (
    <div className="flex flex-col gap-1">
      <Visible if={!isFree && !discountPercent && !!price}>
        <span className="mt-5 text-xs font-medium">{price?.toLocaleString('ru')}</span>
      </Visible>
      <Visible if={!isFree && !!discountPercent}>
        <div className="flex flex-col">
          <span className="text-end text-[0.625rem] text-gray-500">{price?.toLocaleString('ru')}</span>
          <div className="flex items-center gap-1">
            <div className="rounded-full bg-gradient-to-br from-yellow-300 to-orange-600 px-1.5 py-0.5 text-[0.525rem] font-medium text-white">
              PRO
            </div>
            <span className="text-xs font-medium">
              {calculateDiscount(price, discountPercent)?.toLocaleString('ru')}
            </span>
          </div>
        </div>
      </Visible>
      <Visible if={isFree}>
        <div className="rounded-full bg-green-600 px-1.5 py-0.5 text-[0.625rem] text-white">{t('bepul')}</div>
      </Visible>
    </div>
  );
};

export default CoursePrice;
